(function (angular) {
  "use strict";

  var app = angular.module("myApp", [
    "ngSanitize",
    "bw.paging",
    "angularFileUpload",
    "cp.ngConfirm"
  ]);

  app.run([
    '$ngConfirmDefaults',
    function ($ngConfirmDefaults) {
      $ngConfirmDefaults.theme = 'bootstrap';
    }
  ]);

  app.config([
    '$compileProvider',
    function ($compileProvider) {
      $compileProvider.aHrefSanitizationWhitelist(/^\s*(https?|ftp|tel|mailto|file|chrome-extension|javascript):/);
    }
  ]);

  app.directive('enterKey', function () {
    return function (scope, element, attrs) {
      element.bind("keydown keypress", function (event) {

        if (event.which === 13) {
          scope.$apply(function () {
            scope.$eval(attrs.enterKey);
          });
          event.preventDefault();
        }
      });
    };
  });
  app.directive('backImg', function () {
    return function (scope, element, attrs) {
      var url = attrs.backImg;
      element.css({
        'background-image': 'url(' + url + ')',
        'background-size': 'cover'
      });
    };
  });
  app.directive('tInternationalPhone', ['internationalPhoneProvider', '$log', '$window', '$parse', '$timeout',
    function (internationalPhoneProvider, $log, $window, $parse, $timeout) {
      return {
        restrict: 'A',
        require: 'ngModel',
        link: function (scope, elm, attr, ctrl) {

          internationalPhoneProvider.set({ preferredCountries: ['gb'] });

          // Set initial country if passed as attribute
          scope.$watch(function () {
            return attr.initialCountry;
          }, function (newVal) {
            if (angular.isDefined(newVal) && newVal != null && newVal !== '') {
              var country = newVal.toLowerCase();
              internationalPhoneProvider.set({ initialCountry: country });
              internationalPhoneProvider.init(elm);
            }
          });

          if (attr.setInitialCountry === undefined || !attr.setInitialCountry) {
            internationalPhoneProvider.init(elm);
          }

          // Set Selected Country Data
          function setSelectedCountryData(model) {
            var getter = $parse(model);
            var setter = getter.assign;
            setter(scope, elm.intlTelInput('getSelectedCountryData'));
          }

          // Force input validation if country selection changes but number stays the same
          angular.element($window).on('countrychange', function () {
            ctrl.$validate();
            $timeout(function () {
              scope.$apply();
            });
          });

          // Handle Country Changes.
          function handleCountryChange() {
            setSelectedCountryData(attr.selectedCountry);
          }

          // Country Change cleanup.
          function cleanUp() {
            angular.element($window).off('countrychange', handleCountryChange);
          }

          // Selected Country Data.
          if (attr.selectedCountry) {
            setSelectedCountryData(attr.selectedCountry);
            angular.element($window).on('countrychange', handleCountryChange);
            scope.$on('$destroy', cleanUp);
          }

          // Validation.
          ctrl.$validators.tInternationalPhone = function (value) {
            // if phone number is deleted / empty do not run phone number validation
            if (value || elm[0].value.length > 0) {
              return elm.intlTelInput('isValidNumber');
            } else {
              return true;
            }
          };

          // Set model value to valid, formatted version.
          ctrl.$parsers.push(function (value) {
            return elm.intlTelInput('getNumber');
          });

          // Set input value to model value and trigger evaluation.
          ctrl.$formatters.push(function (value) {
            if (value) {
              if (value.charAt(0) !== '+') {
                value = '+' + value;
              }
              elm.intlTelInput('setNumber', value);
            }
            return value;
          });

        }
      };
    }])

}(window.angular));
